import { Navigate } from "react-router-dom";

// Entrar no CRM leva direto ao funil de leads (entrada principal do módulo).
const CRM = () => <Navigate to="/commercial/crm/leads" replace />;

export default CRM;
